import { Component, OnInit } from '@angular/core';
import { MasterService,ClassroomService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-voters',
  templateUrl: './voters.component.html',
  styleUrls: ['./voters.component.scss'],
  providers:[MasterService,ClassroomService]
})
export class VotersComponent implements OnInit {

  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
    sections:any=[];
    classes:any=[];
    arrstf:any=[];
    arrstudent:any=[];
    arrdept:any=[];
    fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0'};
    fmodel1:any={clid:'0',secid:'0',subid:'0',prid:'0'};
    arrrepdata:any=[];
    arrper:any=[];
    arrashead:any=[];
    arrcourse:any=[];
    arrpost:any=[];
    arrastype:any=[];
    arrastype1:any=[];
    dropdownList = [];
    selectedItems = [];
    arrstflst:any=[];
    btntype:any='';
    oprtype:any='';
    objcan:any={};
    tabledata: any = {};
    rcremarks='';
    fileToUpload: File = null;
    // arrcat:any=[{name:'Board'},{name:'Competitive'}];
    arrcat:any=[];
    dropdownSettings:IDropdownSettings = {singleSelection: false,
      idField: 'stuid',
      textField: 'stunm',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true};

fData: FormData = new FormData;
  objvoter: any;
    constructor(private http: HttpClient,private aservice:ClassroomService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }
  
    ngOnInit(): void {
     
      this.mascourse();
      this.gethrmdept();
     
      
      //this.subjects();
      this.fmodel.attdt=this.mservice.getdatetoday();
      this.fmodel.frtime=this.mservice.getcurenttime();
      this.fmodel.totime=this.mservice.getcurenttime();
      
     
    }
  
    
    masclass() {
      // this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
        this.mservice.masclass()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.fmodel.clid=resultArray[0].clid;
              this.fmodel1.clid=resultArray[0].clid;
              this.massection();
            //  this.masperiod();
              
             
          },
          error => console.log("Error :: " + error)
          )
    }

    getcandidate(oprtype) {
      this.aservice.getvotlist(oprtype,this.fmodel1.crid,this.fmodel1.clid,this.fmodel1.secid,this.fmodel1.vctid)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);

              
              this.arrrepdata = resultArray;
             
              
             
          },
          error => console.log("Error :: " + error)
          )
    }

    getvoterstflst() {
      this.aservice.getvotlist("selstf",0,0,0,0)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);

              
              this.arrstflst = resultArray;
             
              
             
          },
          error => console.log("Error :: " + error)
          )
    }
    massection() {
      // this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
       this.mservice.massection()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.sections = resultArray;
              this.fmodel.secid=resultArray[0].scid;
              this.fmodel1.secid=resultArray[0].scid;
             this.getvotecategory();
             
          },
          error => console.log("Error :: " + error)
          )
    }


  
 

      onclasschange()
      {
        this.massection();
        this.getcandidate("selstu");
// this.getstudentsdata("voterstu");
      }
  
      onsecchange()
      {
        // this.massection();
        this.getcandidate("selstu");
// this.getstudentsdata("voterstu");
      }
  


      Savercremarks(obj) {
        var objpost={asid:obj.assid,stuid:obj.stuid,rcremarks:this.rcremarks};
        this.aservice.Savercremarks(objpost)
          .subscribe(result => {
            console.log('ret-loop', result);
            alert(result.message);
            //this.Getsel_sp_masassmodel();
          }, error =>
            alert('error in connection')
          );
      }
  
    
      mascourse() {
        this.mservice.mascourse()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrcourse = resultArray;
                this.fmodel.crid=resultArray[0].crid;
                this.fmodel1.crid=resultArray[0].crid;
                this.masclass();
                //this.fmodel1.crid=resultArray[0].crid;
            },
            error => console.log("Error :: " + error)
            )
      }

getvotecategory() {
        this.aservice.getvotecategory()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrcat = resultArray;
                this.fmodel.vctid=resultArray[0].vctid;
                this.fmodel1.vctid=resultArray[0].vctid;
                this.getcandidate("selstu");
                this.getstudentsdata("voterstu");
                // this.masclass();
                //this.fmodel1.crid=resultArray[0].crid;
            },
            error => console.log("Error :: " + error)
            )
      }

      getposts() {
        this.mservice.masbooth()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrpost = resultArray;
              //  th
                this.fmodel.boothid=resultArray[0].boothid;
            },
            error => console.log("Error :: " + error)
            )
      }
     
      getstudentsdata(oprtype) {
        this.aservice.getstudents_bytype(this.fmodel.clid,this.fmodel.secid,this.fmodel.crid,oprtype,this.fmodel.vctid)
            .subscribe(
            resultArray => {
                console.log('bloodgp', resultArray);

                this.arrstudent=resultArray;
                // this.arrstudent =  resultArray.filter(item => this.arrrepdata.find(y => y.stuid !== item.stuid));
                //                     //  jsonArray.filter((item) => filterArray.includes(item.id));
                console.log('bloodgp', this.arrstudent);
            },
            error => console.log("Error :: " + error)
            )
      }

      opensymbol(content,obj)
{
// this.getaccno_series();
this.objcan=obj;
this.modalOptions = {
  backdrop:'static',
  backdropClass:'customBackdrop',
  size:'md'
 }
this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}


openedit(content,tag)
{
// this.getaccno_series();
this.getposts();
this.btntype=tag;
// this.objcan=obj;
this.modalOptions = {
  backdrop:'static',
  backdropClass:'customBackdrop',
  size:'md'
 }
this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}



openeditbooth(content,obj)
{
// this.getaccno_series();
this.getposts();
this.objvoter=obj;
// this.objcan=obj;
this.modalOptions = {
  backdrop:'static',
  backdropClass:'customBackdrop',
  size:'md'
 }
this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}


openstudent(content)
{
// this.getaccno_series();
this.getposts();
// this.btntype=tag;
// // this.objcan=obj;
this.modalOptions = {
  backdrop:'static',
  backdropClass:'customBackdrop',
  size:'lg'
 }
this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}
      
  
 

 savecbmclassd(boothid) {
  debugger
 
  this.aservice.savevoter(this.fmodel,this.selectedItems,"Student",boothid)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);
//var cbclid=this.fmodel1,cbclid
          alert(resultArray.message);
          if(resultArray.status=='Success')
          {
            
         
         
            let localmodref=this.modalRef;
            localmodref.close();
          this.selectedItems=[];
          this.getcandidate("selstu");
          this.getstudentsdata("voterstu");
          }
      }, error =>
          alert('error in connection')
      );
}

savestfvoter(boothid) {
  debugger
 
  this.aservice.savevoter(this.fmodel,this.selectedItems,"Staff",boothid)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);
//var cbclid=this.fmodel1,cbclid
          alert(resultArray.message);
          if(resultArray.status=='Success')
          {
            
         
            let localmodref=this.modalRef;
            localmodref.close();
          this.selectedItems=[];
          this.getvoterstflst();
          this.getstfdata();
          }
      }, error =>
          alert('error in connection')
      );
}
delvoter(id,type) {
  debugger
 if(confirm("Are you sure you want to remove?"))
 {
  this.aservice.delvoter(id)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);
//var cbclid=this.fmodel1,cbclid
          alert(resultArray.message);
          if(resultArray.status=='Success')
          {
            
         
          this.selectedItems=[];
          if(type=="student")
          {
          this.getcandidate("selstu");
          this.getstudentsdata("voterstu");
          }
          else{
            this.getvoterstflst();
            this.getstfdata();
          }
          }
      }, error =>
          alert('error in connection')
      );
}
}



updbooth(obj) {
 
  this.aservice.updvotbooth(obj.voterid,obj.boothid)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);
//var cbclid=this.fmodel1,cbclid
          alert(resultArray.message);
          if(resultArray.status=='Success')
          {
            
         let localmodref=this.modalRef;
            localmodref.close();
          this.selectedItems=[];
          if(obj.type=="student")
          {
          this.getcandidate("selstu");
          this.getstudentsdata("voterstu");
          }
          else{
            this.getvoterstflst();
            this.getstfdata();
          }
          }
      }, error =>
          alert('error in connection')
      );

}

gethrmdept() {
  this.mservice.get_hrmdept()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.arrdept = resultArray;
//           this.arrdept1=resultArray;
// this.arrdept1.unshift({depid:"0",depnm:"ALL"});
// this.defclass="0";
         
      },
      error => console.log("Error :: " + error)
      )
}


 printform(){
         debugger;
           var clcd=localStorage.getItem('clcd');
           var aycd=localStorage.getItem('aycd');
          
            var url=this.mservice.callurl+"export/exp_abstained.php?clcd="+clcd+"&aycd="+aycd+"&clid="+this.fmodel1.clid+"&scid="+this.fmodel1.secid+"&crid="+this.fmodel1.crid+"&vctid="+this.fmodel1.vctid;
            window.open(url,'','');
          } 
        
onchangedep()
{

}

getstfdata() {
  this.aservice.getstudents_bytype(0,0,0,"voterstf",0)
      .subscribe(
      resultArray => {
          console.log('bloodgp', resultArray);

          this.arrstf=resultArray;
          // this.arrstudent =  resultArray.filter(item => this.arrrepdata.find(y => y.stuid !== item.stuid));
          //                     //  jsonArray.filter((item) => filterArray.includes(item.id));
          // console.log('bloodgp', this.arrstudent);
      },
      error => console.log("Error :: " + error)
      )
}
// updcanpost() {
//   debugger
 
//   this.aservice.updcandidatepost(this.objcan)
//        .subscribe(resultArray => {
//           console.log('ret-loop', resultArray);
// //var cbclid=this.fmodel1,cbclid
//           alert(resultArray.message);
//           if(resultArray.status=='Success')
//           {
//             let localmodref=this.modalRef;
//             localmodref.close();
         
        
//           this.getcandidate();
         
//           }
//       }, error =>
//           alert('error in connection')
//       );
// }
  }
